///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const VerticalMenuIcon = ({
  height,
  fill = "#0C1826",
  title = messages.menu.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="menu-icon"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="menu-icon">{title}</title>
    <path
      fill={fill}
      d="M8 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
    />
  </svg>
);

export default VerticalMenuIcon;
